import { render } from "./LogoutComponent.vue?vue&type=template&id=79936b7c"
import script from "./LogoutComponent.js?vue&type=script&lang=js&external"
export * from "./LogoutComponent.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__